import { PAGE_OPERATION_FOR_VALUE, ROLE_DEFINITIONS } from "helpers/url_helper/url_helper"
import {
  GET_ROLE_DEFINITIONS,
  GET_ROLE_DEFINITIONS_SUCCESS,
  ADD_NEW_ROLE_DEFINITION,
  ADD_ROLE_DEFINITION_SUCCESS,
  UPDATE_ROLE_DEFINITION,
  UPDATE_ROLE_DEFINITION_SUCCESS,
  DELETE_ROLE_DEFINITION,
  DELETE_ROLE_DEFINITION_SUCCESS,
  ROLE_DEFINITION_API_ERROR,
  PAGE_OPERATION_LIST,
  PAGE_OPERATION_LIST_SUCCESS,
  PAGE_OPERATION_LIST_FOR_VALUE,
  PAGE_OPERATION_LIST_FOR_VALUE_SUCCESS

} from "./actionTypes"

// ROLE DEFINITION 

export const getRoleDefinitions = () => ({
  type: GET_ROLE_DEFINITIONS,
})

export const getRoleDefinitionsSuccess = roleDefinition => ({
  type: GET_ROLE_DEFINITIONS_SUCCESS,
  payload: roleDefinition,
})

export const addNewRoleDefinition = roleDefinition => ({
  type: ADD_NEW_ROLE_DEFINITION,
  payload: roleDefinition,
})

export const addRoleDefinitionSuccess = roleDefinition => ({
  type: ADD_ROLE_DEFINITION_SUCCESS,
  payload: roleDefinition,
})

export const updateRoleDefinition = roleDefinition => ({
  type: UPDATE_ROLE_DEFINITION,
  payload: roleDefinition,
})

export const updateRoleDefinitionSuccess = roleDefinition => ({
  type: UPDATE_ROLE_DEFINITION_SUCCESS,
  payload: roleDefinition,
})

export const deleteRoleDefinition = guid => ({
  type: DELETE_ROLE_DEFINITION,
  payload: guid,
})

export const deleteRoleDefinitionSuccess = guid => ({
  type: DELETE_ROLE_DEFINITION_SUCCESS,
  payload: guid,
})

export const roleDefinitionsApiError = error => ({
  type: ROLE_DEFINITION_API_ERROR,
  payload: error,
})
export const getPageOperationListForRoleDefinition = () => ({
  type: PAGE_OPERATION_LIST,
  
})

export const getPageOperationListForRoleDefinitionSuccess = operationList => ({
  type: PAGE_OPERATION_LIST_SUCCESS,
  payload: operationList,
})

export const getPageOperationForValueList = guid => ({
  type: PAGE_OPERATION_LIST_FOR_VALUE,
  payload: guid,
})

export const getPageOperationForValueListSuccess = guid => ({
  type: PAGE_OPERATION_LIST_FOR_VALUE_SUCCESS,
  payload: guid,
})
